module.exports = __webpack_public_path__ + "assets/6bb6e76d6837228e400cd32c854121a8.mp4";